<template>
  <Modal @close="$emit('close')">
    <div slot="body" class="text-center video-responsive">
      <iframe
        :src="videoUrl"
        frameborder="0"
        allow="autoplay; fullscreen"
        allowfullscreen
      ></iframe>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal";

export default {
  name: "ModalVideo",
  components: {
    Modal,
  },
  props: ["videoUrl"],
};
</script>

<style lang="scss" scoped></style>
